import { render, staticRenderFns } from "./ModalCapNhatApp.vue?vue&type=template&id=b98ead38&"
import script from "./ModalCapNhatApp.vue?vue&type=script&lang=js&"
export * from "./ModalCapNhatApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports